import Skeleton from "react-loading-skeleton";
import React, { JSX, useEffect } from "react";
import { NotificationItem } from "../general/NotificationItem";
import { NotificationInterface } from "../../../../common/interfaces/NotificationInterface";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { useGetNotificationsQuery } from "../../../../common/api/notification";
import { useEstablishmentId } from "../../../../common/utils/useEstablishmentId";
import {
    SecondaryPagination,
    EmptyListNotice,
} from "@hatch-digital-nl/abs-storybook/legacy";
import { setCurrentPage, setItemsPerPage } from "../../NotificationsSlice";
import {
    setApproved,
    setIsEditCertificateModalOpen,
    setSelectedCertificateId,
} from "../../../../modals/EditCertificateModal/EditCertificateModalSlice";
import {
    setIsAtQualification,
    setIsCreateCertificateModalOpen,
    setSelectedEmployee,
    setSelectedQualification,
} from "../../../../modals/CreateCertificateModal/CreateCertificateModalSlice";

export const EstablishmentNotifications = (): JSX.Element => {
    const dispatch = useAppDispatch();
    const { itemsPerPage, itemsPerPageSelect, currentPage } = useAppSelector(
        (state) => state.notifications,
    );
    const { isPostCreateCertificateSuccess } = useAppSelector(
        (state) => state.createCertificateModal,
    );
    const {
        isPatchEditCertificateSuccess,
        isOpenFormLoading,
        selectedCertificateId,
    } = useAppSelector((state) => state.editCertificateModal);

    const {
        data: establishmentNotificationsData,
        isLoading: establishmentNotificationsIsloading,
        isFetching: establishmentNotificationsIsFetching,
        refetch: refetchEstablishmentNotifications,
    } = useGetNotificationsQuery({
        page: currentPage,
        items_per_page: itemsPerPage,
        filter: {
            establishment_id: useEstablishmentId(),
        },
    });

    useEffect(() => {
        if (isPostCreateCertificateSuccess || isPatchEditCertificateSuccess) {
            refetchEstablishmentNotifications();
        }
    }, [
        isPostCreateCertificateSuccess,
        isPatchEditCertificateSuccess,
        refetchEstablishmentNotifications,
    ]);

    if (
        establishmentNotificationsIsloading ||
        establishmentNotificationsIsFetching
    ) {
        return <Skeleton height={"9rem"} count={8} borderRadius={"1.5rem"} />;
    }

    if (
        !establishmentNotificationsData ||
        !establishmentNotificationsData.data.length
    ) {
        return <EmptyListNotice content={"Er zijn geen meldingen gevonden"} />;
    }

    return (
        <section className={"p-notifications__content"}>
            {establishmentNotificationsData.data.map(
                (notification: NotificationInterface, index: number) => (
                    <NotificationItem
                        key={index}
                        notification={notification}
                        onClick={() => {
                            if (notification.certificate?.approved === false) {
                                dispatch(setApproved(null));
                                dispatch(
                                    setSelectedCertificateId(
                                        notification.certificate?.id,
                                    ),
                                );
                                dispatch(setIsEditCertificateModalOpen(true));
                                return;
                            }

                            dispatch(setIsAtQualification(false));
                            dispatch(
                                setSelectedEmployee(notification.employee),
                            );
                            dispatch(
                                setSelectedQualification(
                                    notification.qualification,
                                ),
                            );
                            dispatch(setIsCreateCertificateModalOpen(true));
                        }}
                        isLoading={
                            isOpenFormLoading &&
                            selectedCertificateId ===
                                notification.certificate?.id
                        }
                    />
                ),
            )}
            <SecondaryPagination
                itemsPerPage={itemsPerPage}
                totalItems={establishmentNotificationsData?.meta?.total || 0}
                currentPage={currentPage}
                onPaginationChange={(page: number) => {
                    dispatch(setCurrentPage(page));
                }}
                totalItemsOnCurrentPage={
                    establishmentNotificationsData?.data.length || 0
                }
                onItemsPerPageChange={(
                    event: React.ChangeEvent<HTMLSelectElement>,
                ) => dispatch(setItemsPerPage(Number(event.target.value)))}
                itemsPerPageSelect={itemsPerPageSelect}
            />
        </section>
    );
};
